export function getEntryTestSections(activityModel) {
    const sectionIds = Object.keys(activityModel.get('entry_test').task_groups_per_section)
    return sectionIds.map((sectionId) => {
        return Backbone.Collection.sections.get(sectionId)
    })
}

export function getTotalScoreExemptionSections(activityModel) {
    const sectionIds = activityModel.get('entry_test').total_score_exemption_section_ids ?? []
    return sectionIds.map((sectionId) => {
        return Backbone.Collection.sections.get(sectionId)
    })
}

/**
 * All sections a student can get an exemption for through this entry test: the tested sections and the
 * total score exemption sections, in the order they appear in the chapter.
 */
export function getExemptionSections(activityModel) {
    const sections = [...getEntryTestSections(activityModel), ...getTotalScoreExemptionSections(activityModel)]
    const chapterSectionIds = activityModel.getChapterModel()?.getChildren().map(section => section.id) ?? []
    return sections.sort((a, b) => chapterSectionIds.indexOf(a.id) - chapterSectionIds.indexOf(b.id))
}

export function getAttainableTestScoreForSection(activityModel, sectionId) {
    const taskGroupIds = activityModel.get('entry_test').task_groups_per_section[sectionId]
    return taskGroupIds.reduce((total, taskGroupId) => {
        const taskGroup = activityModel.task_groups.get(taskGroupId)
        if (taskGroup) {
            total += taskGroup.tasks.length
        }
        return total
    }, 0)
}

export function getScoreForSection(activityModel, sectionId, userId) {
    // Backend calculates score for when the user is a student.
    if (userId === undefined) {
        return activityModel.get('entry_test').score_per_section[sectionId]?.scored ?? 0
    }
    // Otherwise, calculate score based on responses.
    const taskGroupIds = activityModel.get('entry_test').task_groups_per_section[sectionId]
    return activityModel.responses.reduce((total, response) => {
        if (
            response.get('user_id') === userId &&
            response.has('json_answer') &&
            response.get('score') > -1 &&
            taskGroupIds.includes(activityModel.tasks.get(response.get('task_id'))?.get('task_group_id'))
        ) {
            total += response.get('score')
        }
        return total
    }, 0)
}
